import React from 'react';

const RemoveIcon = ({ className }) => (
    <svg
        width='20'
        height='20'
        viewBox='0 0 20 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={className}
    >
        <g clipPath='url(#clip0_879_2557)'>
            <path
                d='M6.66699 10.0001H13.3337M18.3337 10.0001C18.3337 14.6025 14.6027 18.3334 10.0003 18.3334C5.39795 18.3334 1.66699 14.6025 1.66699 10.0001C1.66699 5.39771 5.39795 1.66675 10.0003 1.66675C14.6027 1.66675 18.3337 5.39771 18.3337 10.0001Z'
                stroke='#667085'
                strokeWidth='1.67'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
        <defs>
            <clipPath id='clip0_879_2557'>
                <rect width='20' height='20' fill='white' />
            </clipPath>
        </defs>
    </svg>
);

export { RemoveIcon };
